import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getQueryType } from "../../../state/selectors/general.selectors";
import { setSelectedCard } from "../../../state/actions/Cards";

function VariantInfoClassifications({
  variantFlags,
  variantClasses,
  queryType,
  dispatchSelectCard,
}) {
  if (
    queryType === "gene" ||
    queryType === "transcript" ||
    queryType === "position" ||
    !variantFlags ||
    !variantClasses ||
    !Array.isArray(variantFlags) ||
    variantFlags.length === 0
  ) {
    return null;
  }

  const flags = variantFlags;
  const topFlags = (flags || []).reduce(
    (a, i) => ({ ...a, [i.flag]: (a[i.flag] || 0) + 1 }),
    {}
  );

  const flagsText = Object.entries(topFlags)
    .map(([cl, num], ind) => {
      const className = variantClasses[cl].name;
      return ind === 0
        ? `${num} user${
            num === 1 ? "" : "s"
          } classified this variant as ${className}`
        : ` ${num} as ${className}`;
    })
    .join(", ");

  useEffect(() => {
    setTimeout(() => {
      // make sure that the diff in height is captured by other components.
      window.dispatchEvent(new Event("resize"));
    }, 50);
  });

  const handleClick = () => {
    dispatchSelectCard("communityContributions");
    const event = new CustomEvent("forceScrollToComponent", {
      detail: "communityContributions",
    });
    document.dispatchEvent(event);
  };

  return (
    <div
      className="tw-text-white tw-text-xs hover:tw-underline tw-cursor-pointer"
      onClick={() => handleClick()}
    >
      {flagsText}.
    </div>
  );
}

VariantInfoClassifications.propTypes = {
  variantFlags: PropTypes.arrayOf(PropTypes.shape({})),
  queryType: PropTypes.string,
  variantClasses: PropTypes.shape({}),
  dispatchSelectCard: PropTypes.func.isRequired,
};

VariantInfoClassifications.defaultProps = {
  variantFlags: [],
  queryType: "",
  variantClasses: null,
};

const mapStateToProps = (state) => ({
  variantFlags: state.variantFlags,
  variantClasses: state.variantClasses,
  queryType: getQueryType(state),
});

const mapDispatchToProps = (dispatch) => ({
  dispatchSelectCard: (params) => dispatch(setSelectedCard(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VariantInfoClassifications);
